/* eslint-disable no-param-reassign */
import { Preferences } from '@capacitor/preferences'
import { createSlice } from '@reduxjs/toolkit'

import { changeLanguage } from '../transifex/transifex'

const subdomainThemeMapping: { [key: string]: string } = {
  smartservice: 'smartservice',
}

const [subdomain] = window.location.href.split('://')[1].split('.')

const initialState = {
  userType: null,
  authToken: null,
  externalPayloadToken: null,
  externalConsumer: null,
  externalRefId: null,
  theme: subdomainThemeMapping[subdomain] || 'light',
  locale: 'en',
  phoneCharacteristics: {
    phoneModel: '',
    appVersion: '',
  },
} as SessionState

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state, action) => {
      if (!action.payload) return { ...initialState, locale: state.locale, authToken: '' }

      if (action.payload.authToken) {
        Preferences.set({ key: 'authToken', value: JSON.stringify(action.payload.authToken) })
      }
      if (action.payload.userType) {
        Preferences.set({ key: 'userType', value: JSON.stringify(action.payload.userType) })
      }
      if (action.payload.locale) {
        changeLanguage(action.payload.locale)
        Preferences.set({ key: 'locale', value: JSON.stringify(action.payload.locale) })
      }

      return { ...state, ...action.payload }
    },
  },
})

export const { setSession } = sessionSlice.actions

export default sessionSlice.reducer
